export default __webpack_public_path__ + "static/media/dots-circle.bd9a8ded.svg";